import {DeviceParamGatewayV3Network} from "./device-param-gateway-v3-network";
import {DeviceParamGatewayV3Cron} from "./device-param-gateway-v3-cron";
import {DeviceParamGatewayV3Server} from "./device-param-gateway-v3-server";
import {DeviceParamGatewayV3OsmosLirisManager} from "./device-param-gateway-v3-osmos-liris-manager";

export class DeviceParamGatewayV3 {
    public dynDns: string = '';
    public networks_idx: number = 0;
    public networks: DeviceParamGatewayV3Network[] = [];
    public cron: DeviceParamGatewayV3Cron = new DeviceParamGatewayV3Cron();
    public server: DeviceParamGatewayV3Server = new DeviceParamGatewayV3Server();
    public osmos_liris_manager: DeviceParamGatewayV3OsmosLirisManager = new DeviceParamGatewayV3OsmosLirisManager();
}
